// libraries
import type { IDxgVehicle } from '@makemydeal/dr-shared-types';

import { StyledSelectedVehicleInfo } from './VehiclePicker.style';
import { Typography } from '@interstate/components/Typography';
import { getVehicleFields } from '../../utils/vehicleUtils';

export type SelectedVehicleInfoProps = {
    selectedVehicle: IDxgVehicle;
};

export const SelectedVehicleInfo = ({ selectedVehicle }: SelectedVehicleInfoProps) => {
    const { inventoryType, year, make, model, trim } = selectedVehicle;

    const renderField = (label: string, value: string | number | undefined | null, testId: string) => (
        <div data-testid={testId} key={testId} className="vehicle-field">
            <Typography variant="body-md" className="field-label">
                {label}:
            </Typography>
            <span className="field-value">{value}</span>
        </div>
    );

    const vehicleFields = getVehicleFields(selectedVehicle);

    return (
        <StyledSelectedVehicleInfo data-testid="selected-vehicle-info">
            <div className="selected-vehicle-info-left">
                <Typography
                    variant="h6"
                    sx={{ marginBottom: '16px' }}
                    data-testid="selected-vehicle-name"
                    className="selected-vehicle-name"
                >
                    {inventoryType} {year} {make} {model} {trim}
                </Typography>
                {vehicleFields.map((field) => renderField(field.label, field.value, field.testId))}
            </div>
        </StyledSelectedVehicleInfo>
    );
};
